<template>
  <div class="vp-max-w-3xl">
    <div>
      <TheHeader
        title="Features of Vepaar Card"
        desc="Vepaar Cards is a free, eco-friendly bio link platform that simplifies networking. Share all your details via one link, save contacts instantly, and connect effortlessly with NFC technology."
      />

      <CardsShell>
        <!-- {Product} -->
        <TheCard
          icon-color="pink"
          :icon="$options.icons.Link"
          title="Bio Link"
          desc="Easily use it as your Instagram, TikTok, or Twitter bio. Share all your details through a single, streamlined link."
        />

        <TheCard
          :icon="$options.icons.Nfc"
          icon-color="cyan"
          title="Easy to Share"
          desc="Store the link on an NFC card to instantly share your details, simplifying networking like never before."
        />

        <TheCard
          :icon="$options.icons.AddContact"
          icon-color="warning"
          title="Save To Phonebook"
          desc="With a single click, Vepaar Cards let others save your contact directly to their phone—no manual typing or sharing."
        />

        <TheCard
          icon-color="blue"
          title="Multiple Contacts"
          desc="Create an organizational card with ease by adding multiple contacts in one place."
          :icon="$options.icons.ContactBook"
        />

        <TheCard
          :icon="$options.icons.Free"
          icon-color="danger"
          title="Free to Use"
          desc="Enjoy all the benefits of Vepaar Cards at no cost!"
        />

        <TheCard
          :icon="$options.icons.EcoFriendly"
          icon-color="success"
          title="Paperless"
          desc="Go fully digital and reduce waste, contributing to a greener planet."
        />
      </CardsShell>
    </div>
  </div>
</template>
<script>
import {
  Link,
  Nfc,
  AddContact,
  ContactBook,
  Free,
  EcoFriendly,
} from "icons/icons.js";
import TheCard from "components/src/features/_card.vue";
import TheHeader from "components/src/features/_header.vue";
import CardsShell from "components/src/features/_cards-shell.vue";
export default {
  components: {
    TheCard,
    TheHeader,
    CardsShell,
  },
  icons: {
    Link,
    Nfc,
    AddContact,
    ContactBook,
    Free,
    EcoFriendly,
  },
};
</script>
